<template>
    <transition name="loading">
        <div class="loading" v-show="!_LOADING && position == 'bottom'">
        <!-- <div class="loading" v-if="true"> -->
            <div class="dot-wrapper">
                <span class="dot"></span>
                <span class="dot"></span>
            </div>
        </div>
    </transition>
</template>

<script>
    import { mapGetters } from 'vuex'
    import store from '@/store/index'
    export default {
        name: "loadingMore",
        computed: {
            ...mapGetters(['_LOADING']),
            position(){
                return this.$store.getters._LoadingPosition
            }
        }
    }
</script>

<style lang="scss" scoped type="text/scss">
    @keyframes leftdot {
        0% {
          transform: translateX(0);
        }
        50% {
          transform: translateX(25px);
        }
        100% {
          transform: translateX(0);
        }
    }

    @keyframes rightdot {
        0% {
            transform: translateX(0);
        }
        50% {
            transform: translateX(-25px);
        }
        100% {
            transform: translateX(0);
        }
    }
    .loading {
        height: j(60);
        margin-top: j(80);
        padding-bottom: j(80);
        width: 100%;
        justify-content: center;
        align-items: center;
        display: flex;
        p {
            text-align: center;
            font-size: j(24);
            color: #9B9DA9;
        }
    }

    .dot-wrapper {
        width: 35px;
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 10px;
    }

    .dot {
        display: block;
        width: 10px;
        height: 10px;
        background: $defaultColor;
        border-radius: 50%;
        animation-iteration-count: infinite;
        animation-duration: 1.1s;
        &:nth-child(1) {
            animation-name: leftdot;
        }
        &:nth-child(2) {
            animation-name: rightdot;
            background: #00dada;
        }
    }

    .loading-enter-active, .loading-leave-active {
        transition: opacity .1s;
    }
    .loading-enter,.loading-leave-to{
        opacity: 0
    }

</style>


// WEBPACK FOOTER //
// src/components/loadingMore.vue